import 'whatwg-fetch';
import * as PIXI from 'pixi.js';
import Game from './Game';
import { Cursor } from './GameKit/Cursor';
import Loader from './Game/Base/Loader';

export default class GameContext {
    constructor(pixiApp, game, ui) {
        this.ui = ui;
        this.game = game;
        this.pixiApp = pixiApp;

        this.gameID = '';

        this.eventTime = 0;
        this.eventFunc = null;
    }

    initPixi(wrapper, id) {
        const gameWrapper = document.getElementById(wrapper);

        PIXI.utils.skipHello();
        this.pixiApp = new PIXI.Application({
            autoStart: false,
            width: gameWrapper.clientWidth,
            height: gameWrapper.clientHeight,
            backgroundColor: 0x515151,
            preserveDrawingBuffer: true,
            antialias: true,
            autoResize: true,
            resolution: 1,
            forceCanvas: false
        });
        this.pixiApp.view.id = id;
        this.pixiApp.view.classList.add('game-canvas');
        this.canvas = this.pixiApp.view;
        gameWrapper.appendChild(this.pixiApp.view);

        /* if (this.pixiApp.renderer instanceof PIXI.CanvasRenderer) {
            store.dispatch(OpenPopup(PopupTypes.NOWEBGL));
            throw new Error('WebGL is niet ondersteund in deze browser.');
        } */

        this.game.setRenderApplication(this.pixiApp);
    }

    setTimeout(func, time) {
        this.eventFunc = func;
        this.eventTime = time;
    }

    clearTimeout() {
        this.eventFunc = null;
        this.eventTime = 0;
    }

    updateTimeout() {
        if (this.eventTime > 0) {
            this.eventTime -= this.game.deltaTime;
            if (this.eventTime <= 0) {
                this.eventTime = 0;
                if (this.eventFunc) {
                    const f = this.eventFunc.bind(this);
                    this.eventFunc = null;
                    f();
                }
            }
        }
    }

    render() {
        this.game.update();
        this.updateTimeout();
        window.requestAnimationFrame(this.render.bind(this));
    }

    makeScreenshot() {
        const copyCanvas = document.createElement('canvas');
        copyCanvas.width = 48;
        copyCanvas.height = 27;
        const copyCtx = copyCanvas.getContext('2d');

        copyCtx.drawImage(this.pixiApp.renderer.view, 0, 0, copyCanvas.width, copyCanvas.height);

        const dat = {
            uuid: this.game.activeLevel.uuid,
            image: copyCanvas.toDataURL()
        };

        let found = false;
        for (let i = 0; i < this.madeScreenshots.length; i++) {
            const item = this.madeScreenshots[i];
            if (item.uuid === dat.uuid) {
                item.image = dat.image;
                found = true;
                break;
            }
        }
        if (!found) {
            this.madeScreenshots.push(dat);
        }
        return dat.image;
    }

    setCursor(type) {
        switch (type) {
            case Cursor.def:
                this.canvas.style.cursor = 'default';
                break;
            case Cursor.grab:
                this.canvas.style.cursor = 'grab';
                break;
            case Cursor.grabbing:
                this.canvas.style.cursor = 'grabbing';
                break;
            case Cursor.pointer:
                this.canvas.style.cursor = 'pointer';
                break;
            default:
                this.canvas.style.cursor = 'default';
                break;
        }
    }
}
